import { useState, useEffect } from "react";
import { axios } from "../../../services";

export const useFetchMessages = (communityId) => {
  const [messages, setMessages] = useState([]);

  const fetchMessages = async () => {
    try {
      const { data } = await axios.get(`/chat/${communityId}`);
      setMessages(data.data || []);
    } catch (err) {
      console.log("Error fetching messages:", err);
    }
  };

  useEffect(() => {
    if (communityId) {
      fetchMessages();
    }
  }, [communityId]);

  return { messages, fetchMessages };
};
